import { GenericDataApi } from '@/lib/data/GenericDataApi';
import { AxiosError } from 'axios';
import AppHttp from '../AppHttp';
import Errors from '../Errors';
import { Crew } from '@/models/api';
export class Crews extends GenericDataApi<Crew> {
    constructor() {
        super('Crews');
    }

    public async export() {
        const response = await AppHttp.get(`${this.resource}/export`);
        const data = response ? response.data : null;
        return data;
    }
    public async import(file: any) {
        const response = await AppHttp.postWithFiles(`${this.resource}/import`, {}, [file]);
        const data = response ? response.data : null;
        return data;
    }
    async saveCrew(model: any) {
        const response = await AppHttp.post(`${this.resource}/save`, model);
        const data = response ? response.data : null;
        return data;
    }
}

export default new Crews();
